import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './components/pages/Home';
import Layout from './components/Layout';
import Appointment from './components/pages/Appointment';
import NotFound from './components/pages/NotFound';

function App() {
  return (
    <>
      <HelmetProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/" element={ <Layout/> } >
              <Route 
                path=":practice_slug" 
                element={
                  <Appointment />
                } 
              />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </>
  );
}

export default App;
